import React, { useState, useEffect } from "react";
import Adminsidebar from "../components/Adminsidebar";
import Adminheader from "../components/Adminheader";
import Uppercase from "../components/Uppercase";
import { FaDownload, FaPlus } from "react-icons/fa";
import * as XLSX from "xlsx";
import axios from "axios";
import { useYearContext } from "../components/YearContext";
import {toast} from "react-toastify";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FaUserEdit } from "react-icons/fa";



function Employeeinfo() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const { yearSelected } = useYearContext();
  const [employees, setEmployees] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [loading, setLoading] = useState(false); // For loading state
  const [showAddEmployee, setShowAddEmployee] = useState(false);
  const [newEmployee, setNewEmployee] = useState({
    username: "",
    email: "",
    workEmail: "",
    contact: "",
    role: "",
    department: "",
    password: "",
    targetAssigned: "",
    dateHired: "",
    status: "Active",
  });

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const response = await axios.get(
          "https://api.litaxfilers.com/api/employeesinfo"
        );
        setEmployeeData(response.data);
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }
    };
    fetchEmployeeData();
  }, []);

  const formatDateTime = (dateTime) => new Date(dateTime).toLocaleDateString();

  const handleAddEmployee = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://api.litaxfilers.com/api/employees", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newEmployee),
      });
      const data = await response.json();

      if (response.ok) {
        toast.success("Employee added successfully!");
        setNewEmployee({
          username: "",
          email: "",
          workEmail: "",
          contact: "",
          role: "",
          password: "",
          department: "",
          targetAssigned: "",
          dateHired: "",
          status: "Active",
        });
        setShowAddEmployee(false);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("Error adding employee:", error);
    }
  };
  const deleteEmployee = async (empId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33", // Red button for confirmation
      cancelButtonColor: "#3085d6", // Blue button for cancel
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.delete(`https://api.litaxfilers.com/api/deleteemployee/${empId}`);
          
          if (response.status === 200) {
            Swal.fire("Deleted!", "The employee has been deleted.", "success");
            
            // Update the employee list in the frontend after deletion
            setEmployeeData((prevEmployees) =>
              prevEmployees.filter((employee) => employee.empId !== empId)
            );
          } else {
            toast.error("Failed to delete the employee.");
          }
        } catch (error) {
          console.error("Error deleting employee:", error);
          Swal.fire("Error!", "An error occurred while deleting the employee.", "error");
        }
      } else {
        Swal.fire("Cancelled", "The employee is safe!", "info");
      }
    });
  };

  const updatePassword = async(id) => {
try{
const response = await axios.put(`https://api.litaxfilers.com/updateemppwd/${id}`);
if(response.data.success){
  toast.success("Password updated to 123456");
}
}catch(error){
  console.log(error);
}
  }

  const downloadTableAsExcel = () => {
    const ws = XLSX.utils.json_to_sheet(
      filterDocuments.map((employee) => ({
        ID: employee.id,
        Name: employee.username,
        Email: employee.email,
        "Work Email": employee.workEmail,
        Contact: employee.contact,
        Role: employee.role,
        Department: employee.department,
        "Target Assigned": employee.targetAssigned,
        "Date Hired": formatDateTime(employee.dateHired),
        Status: employee.status,
      }))
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Employees");
    XLSX.writeFile(wb, "employees.xlsx");
  };

  //filters
  const [filters, setFilters] = useState({
    dateFrom: "",
    dateTo: "",
    employeeName: "",
    status: "",
  });

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const filterDocuments = employeeData.filter((doc) => {
    const { dateFrom, dateTo, employeeName, status } = filters;
    const lowerCaseStatus = status.toLowerCase();
    const fromDate = dateFrom ? dateFrom : "";
    const toDate = dateTo ? dateTo : new Date().toISOString().substring(0, 10);
    const documentDate = doc.dateHired ? doc.dateHired.substring(0, 10) : "";

    const nextYear = (parseInt(yearSelected) + 1).toString();
    const startDate = `${parseInt(nextYear) - 1}-09-01`;
    const endDate = `${nextYear}-08-31`;
    return (
      documentDate >= startDate &&
      documentDate <= endDate &&
      (dateFrom === "" || doc.dateHired >= fromDate) &&
      (dateTo === "" || doc.dateHired <= toDate) &&
      (employeeName === "" ||
        doc.username.toLowerCase().includes(employeeName.toLowerCase())) &&
      (status === "" || doc.status.toLowerCase() === lowerCaseStatus)
    );
  });

  const reversedDocuments = filterDocuments.slice().reverse();

  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 100;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = reversedDocuments.slice(firstIndex, lastIndex);
  const npage = Math.ceil(filterDocuments.length / recordsPerPage);
  const numbers = [...Array(npage + 1).keys()].slice(1);

  const prePage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const changeCpage = (id) => {
    setCurrentPage(id);
  };
  const nextPage = () => {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div>
      <Uppercase />
      <div className="invoice-grid-container">
        <Adminheader openSidebar={openSidebar} />
        <Adminsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container">
          <div
  className="row mt-2"
  style={{
    fontSize: "12px", // Smaller text size
   
    marginBottom: "5px",
    
  }}
>
             
          
  {/* Row for Controls */}
  <div
    className="d-flex align-items-center justify-content-between gap-3 mt-2"
    style={{ fontSize: "12px", marginBottom: "5px" }}
  >
    {/* Add Employee Button */}
    <button
      className="btn btn-primary"
      onClick={() => setShowAddEmployee(!showAddEmployee)}
      style={{ minWidth: "150px", lineHeight: "1" }}
    >
      <FaPlus /> Add Employee
    </button>

    {/* Date From Input */}
    <input
      type="date"
      className="form-control form-control-sm"
      name="dateFrom"
      value={filters.dateFrom}
      onChange={handleFilterChange}
      style={{ maxWidth: "150px" }}
    />

    {/* Date To Input */}
    <input
      type="date"
      className="form-control form-control-sm"
      name="dateTo"
      value={filters.dateTo}
      onChange={handleFilterChange}
      style={{ maxWidth: "150px" }}
    />

    {/* Employee Name Input */}
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Employee Name"
      name="employeeName"
      value={filters.employeeName}
      onChange={handleFilterChange}
      style={{ maxWidth: "200px" }}
    />

    {/* Status Select */}
    <select
      className="form-select form-select-sm"
      name="status"
      value={filters.status}
      onChange={handleFilterChange}
      style={{ maxWidth: "150px" }}
    >
      <option value="">All</option>
      <option value="Active">Active</option>
      <option value="Inactive">Inactive</option>
    </select>
    <button
  className="btn btn-secondary"
  onClick={downloadTableAsExcel}
  style={{ minWidth: "50px", lineHeight: "1" }}
>
  <FaDownload /> 
</button>

  </div>


  

  {/* Add Employee Form */}
  {showAddEmployee && (
    <div className="mt-3">
      <h3>Add New Employee</h3>
      <form onSubmit={handleAddEmployee}>
        <div className="form-group mb-2">
          <label>Username</label>
          <input
            type="text"
            className="form-control"
            value={newEmployee.username}
            onChange={(e) =>
              setNewEmployee({ ...newEmployee, username: e.target.value })
            }
          />
        </div>
        <div className="form-group mb-2">
          <label>Email</label>
          <input
            type="email"
            className="form-control"
            value={newEmployee.email}
            onChange={(e) =>
              setNewEmployee({ ...newEmployee, email: e.target.value })
            }
          />
        </div>
        <div className="form-group mb-2">
          <label>Work Email</label>
          <input
            type="email"
            className="form-control"
            value={newEmployee.workEmail}
            onChange={(e) =>
              setNewEmployee({ ...newEmployee, workEmail: e.target.value })
            }
          />
        </div>
        <div className="form-group mb-2">
          <label>Password</label>
          <input
            type="password"
            className="form-control"
            value={newEmployee.password}
            onChange={(e) =>
              setNewEmployee({ ...newEmployee, password: e.target.value })
            }
            required
          />
        </div>
        <div className="form-group mb-2">
          <label>Contact</label>
          <input
            type="text"
            className="form-control"
            value={newEmployee.contact}
            onChange={(e) =>
              setNewEmployee({ ...newEmployee, contact: e.target.value })
            }
          />
        </div>
        <div className="form-group mb-2">
          <label>Role</label>
          <select
            className="form-control"
            value={newEmployee.role}
            onChange={(e) =>
              setNewEmployee({ ...newEmployee, role: e.target.value })
            }
          >
            <option value="">Select Role</option>
            <option value="Jr CRE">
              Client Relationship Executive
            </option>
            <option value="Sr CRE">
              Senior Client Relationship Executive
            </option>
            <option value="Team Lead">Team Lead</option>
            <option value="Jr Preparer">Preparer</option>
            <option value="Sr Preparer">Senior Preparer</option>
            <option value="Jr Reviewer">Reviewer</option>
            <option value="Sr Reviewer">Senior Reviewer</option>
            <option value="Marketing Manager">Marketing Manager</option>
<option value="Social Media Manager">Social Media Manager</option>
<option value="Sales Manager">Sales Manager</option>
<option value="Sales Development Representative">Sales Development Representative</option>
<option value="HR Manager">HR Manager</option>
            
          </select>
        </div>
        <div className="form-group mb-2">
          <label>Department</label>
          <select
            className="form-control"
            value={newEmployee.department}
            onChange={(e) =>
              setNewEmployee({ ...newEmployee, department: e.target.value })
            }
          >
            <option value="">Select Department</option>
            <option value="Taxation">Taxation</option>
            <option value="Marketing">Marketing</option>
            <option value="Sales">Sales</option>
            <option value="HR">HR</option>
          </select>
        </div>
        <div className="form-group mb-2">
          <label>Target Assigned</label>
          <input
            type="number"
            className="form-control"
            placeholder="Ex: $ 10000"
            value={newEmployee.targetAssigned}
            onChange={(e) =>
              setNewEmployee({
                ...newEmployee,
                targetAssigned: e.target.value,
              })
            }
          />
        </div>
        <div className="form-group mb-2">
          <label>Date Hired</label>
          <input
            type="date"
            className="form-control"
            value={newEmployee.dateHired}
            onChange={(e) =>
              setNewEmployee({ ...newEmployee, dateHired: e.target.value })
            }
          />
        </div>
        <div className="form-group mb-2">
          <label>Status</label>
          <select
            className="form-control"
            value={newEmployee.status}
            onChange={(e) =>
              setNewEmployee({ ...newEmployee, status: e.target.value })
            }
          >
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>
        <button type="submit" className="btn btn-primary mt-1">
          Add Employee
        </button>
      </form>
    </div>
  )}
</div>


              
              
           
                  <div className="table-container"  style={{
    height: "calc(89vh - 150px)", // Adjust the 150px based on your header/pagination height
    padding: "0",
    border: "1px solid #ccc",
  }}>
                  <div className="table-responsive tablediv">
                  <table
      className="table table-hover table-bordered"
      style={{
        fontSize: "12px", // Smaller font size
        lineHeight: "1.2", // Reduce line height for compact view
      }}
    >
                      <thead className="table-primary">
                        <tr>
                        <th style={{ padding: "5px" }}>S.No</th>
                        <th style={{ padding: "5px" }}>Emp ID</th>
                        <th style={{ padding: "5px" }}>Name</th>
                        <th style={{ padding: "5px" }}>Email</th>
                        <th style={{ padding: "5px" }}>Work Email</th>
                        <th style={{ padding: "5px" }}>Contact</th>
                        <th style={{ padding: "5px" }}>Role</th>
                        <th style={{ padding: "5px" }}>Department</th>
                        <th style={{ padding: "5px" }}>Target</th>
                        <th style={{ padding: "5px" }}>Date Hired</th>
                        <th style={{ padding: "5px" }}>Status</th>
                        <th style={{ padding: "5px" }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {records.length > 0 ? (
                          records.map((employee,index) => (
                            <tr key={employee.id}>
                            <td style={{ padding: "5px" }}>{filterDocuments.length - ((currentPage - 1) * recordsPerPage + index)}</td>
                            <td style={{ padding: "5px" }}>{employee.empId}</td>
                            <td style={{ padding: "5px" }}>{employee.username}</td>
                            <td style={{ padding: "5px" }}>{employee.email}</td>
                            <td style={{ padding: "5px" }}>{employee.workEmail}</td>
                            <td style={{ padding: "5px" }}>{employee.phoneNumber}</td>
                            <td style={{ padding: "5px" }}>{employee.role}</td>
                            <td style={{ padding: "5px" }}>{employee.department}</td>
                            <td style={{ padding: "5px" }}>{employee.targetAssigned}</td>
                            <td style={{ padding: "5px" }}>{formatDateTime(employee.dateHired)}</td>
                            <td style={{ padding: "5px" }}>{employee.status}</td>
                            <td style={{ padding: "5px" }}>
                {/* Edit Button */}
                <Link to={`/edit-employee/${employee.empId}`}>
                  <button className="btn btn-sm btn-primary">Edit</button>
                </Link>
        
                     
  <button
    className="btn btn-danger btn-sm" // Styling for the delete button
    onClick={() => deleteEmployee(employee.empId)}
  >
    Delete
  </button>
  <button
    className="btn btn-warning btn-sm" // Styling for the delete button
    onClick={() => updatePassword(employee.empId)}
  >
    <FaUserEdit/>Password
  </button>
</td>

                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="10">No employees found.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  </div>
                
              </div>

              <nav className="mt-2">
              <ul
    className="pagination"
    style={{
      fontSize: "10px", // Reduce font size
      padding: "0", // Remove unnecessary padding
    }}
  >
                  <li className="page-item">
                  <a href="#" className="page-link" onClick={prePage}  style={{
          padding: "2px 5px", // Adjust padding for smaller height
          height: "auto", // Allow height to adjust with padding
          fontSize: "12px",
        }}>
                      Prev
                    </a>
                  </li>
                  {numbers.map((n, i) => {
                    return (
                      <li
                        className={`page-item ${
                          currentPage === n ? "active" : ""
                        }`}
                        key={i}
                      >
                       <a
                        href="#"
                        className="page-link"
                        onClick={() => changeCpage(n)}
                        style={{
              padding: "2px 5px", // Reduce padding
              height: "auto", // Consistent height
              fontSize: "12px",
            }}
                      >
                          {n}
                        </a>
                      </li>
                    );
                  })}
                  <li className="page-item">
                  <a href="#" className="page-link" onClick={nextPage}
                  style={{
          padding: "2px 5px", // Same padding as above
          height: "auto", // Adjust height
          fontSize: "12px",
        }}
                  >
                      Next
                    </a>
                  </li>
                </ul>
              </nav>
           

        </main>
      </div>
    </div>
  );
}

export default Employeeinfo;
